import { useSearchParams } from "react-router-dom";
import useStorage from "../../../hooks/useStorage";
import { SUBSCRIPTION_URL_PARAMS } from "../const";

const useYaraSubscription = () => {
  const [searchParams] = useSearchParams();
  const shouldUseYaraSubscription = searchParams.has(
    SUBSCRIPTION_URL_PARAMS.YARA
  );
  const [yaraSubscriptions, setYaraSubscription] = useStorage(
    "yara_subscription",
    []
  );

  return {
    yaraSubscriptions: yaraSubscriptions ?? [],
    shouldUseYaraSubscription,
    setYaraSubscription
  };
};

export default useYaraSubscription;
